module.exports = __webpack_public_path__ + "fonts/303681250ec284d7a6b85166db69dd3d.svg";